<svg class="icon-context" [class.active]="isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
    viewBox="0 0 16 16" fill="none">
    <path
        d="M15.5 13.5V2.5C15.5 1.94772 15.0523 1.5 14.5 1.5H1.5C0.947715 1.5 0.5 1.94772 0.5 2.5V13.5C0.5 14.0523 0.947715 14.5 1.5 14.5H14.5C15.0523 14.5 15.5 14.0523 15.5 13.5Z"
        stroke="var(--text-color-dark)" />
    <circle cx="5" cy="6" r="1.5" stroke="var(--text-color-dark)" />
    <path
        d="M4.3753 10.2809L1.64988 13.6877C1.38797 14.015 1.62106 14.5 2.04031 14.5H14.2121C14.5786 14.5 14.8206 14.1187 14.6645 13.7871L11.7734 7.6434C11.4379 6.93044 10.4479 6.86755 10.0249 7.53232L7.79912 11.03C7.63941 11.2809 7.29723 11.3378 7.06494 11.152L5.78087 10.1247C5.34961 9.77969 4.72031 9.84961 4.3753 10.2809Z"
        stroke="var(--text-color-dark)" />
</svg>
